// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-input {
  text-align: center;
  display: block;
  margin: 0 auto;
  border: none;
  padding: 0;
  font-family: AppFont, serif;
  color: var(--ion-color-primary);
  font-size: 16px;
}

ion-item {
  min-height: 50px;
  border: none;
  --border-width: 0px !important;
  margin-top: 50px;
  border-top: 0.6px solid var(--ion-color-primary);
  border-bottom: 0.6px solid var(--ion-color-primary);
}

.wrapper {
  padding: 20px;
  background: var(--background-default);
}
.wrapper .title {
  font-family: AppFontBold, sans-serif;
  font-size: 24px;
  line-height: 26.4px;
  color: var(--color-black);
  margin-bottom: 10px;
}
.wrapper .info {
  font-size: 16px;
  line-height: 20.32px;
  letter-spacing: 0.01em;
}
.wrapper ion-input {
  font-size: 36px;
  font-family: AppFontBold, sans-serif;
  color: var(--ion-color-primary);
  --padding-top: 18px;
  --padding-bottom: 18px;
}

.input-error {
  --border-color: red;
}

ion-header {
  min-height: 60px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 21px 22px;
  box-shadow: 0px 4px 56px 0px rgba(0, 0, 0, 0.0705882353);
}
ion-header .logo {
  height: 24px;
  width: 140px;
}
ion-header .change-language ion-icon {
  height: 31px;
  width: 31px;
  border-radius: 50%;
  border: 2px solid white;
  margin-right: 20px;
}
ion-header .wrapper-icons {
  display: flex;
  align-items: center;
}
ion-header .wrapper-icons ion-icon {
  margin-left: 10px;
}

ion-button {
  width: 100%;
  font-size: 16px;
  line-height: 19.2px;
  letter-spacing: 0.2em;
}`, "",{"version":3,"sources":["webpack://./src/app/components/select-table-modal/select-table-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,2BAAA;EACA,+BAAA;EACA,eAAA;AACD;;AAGA;EACC,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,gDAAA;EACA,mDAAA;AAAD;;AAEA;EACC,aAAA;EACA,qCAAA;AACD;AACC;EACC,oCAAA;EAEA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAAF;AAGC;EACC,eAAA;EACA,oBAAA;EACA,sBAAA;AADF;AAGC;EACC,eAAA;EACA,oCAAA;EACA,+BAAA;EAEA,mBAAA;EACA,sBAAA;AAFF;;AAKA;EACC,mBAAA;AAFD;;AAIA;EACC,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,wDAAA;AADD;AAIC;EACC,YAAA;EACA,YAAA;AAFF;AAKE;EACC,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;AAHH;AAMC;EACC,aAAA;EACA,mBAAA;AAJF;AAKE;EACC,iBAAA;AAHH;;AAOA;EACC,WAAA;EAEA,eAAA;EACA,mBAAA;EACA,qBAAA;AALD","sourcesContent":["ion-input {\n\ttext-align: center;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tborder: none;\n\tpadding: 0;\n\tfont-family: AppFont, serif;\n\tcolor: var(--ion-color-primary);\n\tfont-size: 16px;\n\n\n}\nion-item {\n\tmin-height: 50px;\n\tborder: none;\n\t--border-width: 0px !important;\n\tmargin-top: 50px;\n\tborder-top: 0.6px solid var(--ion-color-primary);\n\tborder-bottom: 0.6px solid var(--ion-color-primary);\n}\n.wrapper {\n\tpadding: 20px;\n\tbackground: var(--background-default);\n\n\t.title {\n\t\tfont-family: AppFontBold, sans-serif;\n\n\t\tfont-size: 24px;\n\t\tline-height: 26.4px;\n\t\tcolor: var(--color-black);\n\t\tmargin-bottom: 10px;\n\t\t// text-transform: uppercase;\n\t}\n\t.info {\n\t\tfont-size: 16px;\n\t\tline-height: 20.32px;\n\t\tletter-spacing: 0.01em;\n\t}\n\tion-input {\n\t\tfont-size: 36px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\tcolor: var(--ion-color-primary);\n\n\t\t--padding-top: 18px;\n\t\t--padding-bottom: 18px;\n\t}\n}\n.input-error {\n\t--border-color: red;\n}\nion-header {\n\tmin-height: 60px;\n\tbackground: #fff;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 21px 22px;\n\tbox-shadow: 0px 4px 56px 0px #00000012;\n\n\n\t.logo {\n\t\theight: 24px;\n\t\twidth: 140px;\n\t}\n\t.change-language {\n\t\tion-icon {\n\t\t\theight: 31px;\n\t\t\twidth: 31px;\n\t\t\tborder-radius: 50%;\n\t\t\tborder: 2px solid white;\n\t\t\tmargin-right: 20px;\n\t\t}\n\t}\n\t.wrapper-icons {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tion-icon {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t}\n}\nion-button {\n\twidth: 100%;\n\n\tfont-size: 16px;\n\tline-height: 19.2px;\n\tletter-spacing: 0.2em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
